import { useState } from "react";
import Reveal from "@/components/feature/Reveal";
import { topicList } from "@/mocks/homeContent";

export default function TopicSection() {
  const [active, setActive] = useState("傍晚爆料");

  return (
    <section id="topics" className="border-t border-background-200/70 bg-background-100/60">
      <div className="mx-auto w-full max-w-page px-4 py-12 md:px-8 md:py-16">
        <Reveal>
          <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
            <div className="max-w-2xl">
              <h2 className="font-heading text-2xl font-semibold text-foreground-950 md:text-[30px]">
                顺着话题往下翻
              </h2>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600 md:text-base">
                点一个话题，就是一条看料的入口。今晚热度高的，基本都在这几个词里。
              </p>
            </div>
            <span className="self-start text-xs text-foreground-500 md:text-sm">
              共 12 个话题 · 每日滚动更新
            </span>
          </div>
        </Reveal>

        <Reveal delay={70}>
          <div className="mt-7 flex flex-wrap gap-2.5 md:gap-3">
            {topicList.map((topic) => (
              <button
                key={topic}
                type="button"
                onClick={() => setActive(topic)}
                className={
                  active === topic
                    ? "cursor-pointer whitespace-nowrap rounded-full bg-primary-500 px-4 py-2 text-sm text-background-50 transition-colors"
                    : "cursor-pointer whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-4 py-2 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
                }
              >
                #{topic}
              </button>
            ))}
          </div>
        </Reveal>

        <Reveal delay={120}>
          <div className="mt-7 flex flex-wrap items-center gap-x-6 gap-y-3 rounded-lg border border-background-200 bg-background-50 px-5 py-4">
            <span className="flex items-center gap-2 text-sm text-foreground-600">
              <span className="flex h-4 w-4 items-center justify-center text-accent-500">
                <i className="ri-price-tag-3-line text-base" />
              </span>
              当前话题：<span className="font-medium text-foreground-950">#{active}</span>
            </span>
            <a
              href="#wall"
              className="ml-auto flex items-center gap-1.5 whitespace-nowrap text-sm text-primary-600 transition-colors hover:text-primary-700"
            >
              查看该话题下的新料
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-arrow-right-line text-base" />
              </span>
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}